var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", [
    _c("div", { staticClass: "form-icon-input" }, [
      _c("div", [_c("Icon", { attrs: { icon: "search" } })], 1),
      _vm._v(" "),
      _c(
        "div",
        [
          _c("b-input", {
            ref: "text",
            attrs: { placeholder: _vm.placeholder },
            on: { input: _vm.onValueChanged },
            model: {
              value: _vm.text,
              callback: function($$v) {
                _vm.text = $$v
              },
              expression: "text"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.hasText
        ? _c("div", [
            _c(
              "a",
              {
                attrs: { href: "#" },
                on: {
                  click: function($event) {
                    $event.preventDefault()
                    return _vm.resetText.apply(null, arguments)
                  }
                }
              },
              [_c("Icon", { attrs: { icon: "close" } })],
              1
            )
          ])
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.catalogInfo
      ? _c(
          "div",
          { staticClass: "mt-2" },
          [
            _c("JonInfo", {
              scopedSlots: _vm._u(
                [
                  {
                    key: "message",
                    fn: function() {
                      return [
                        _c("span", {
                          domProps: { innerHTML: _vm._s(_vm.catalogInfo) }
                        })
                      ]
                    },
                    proxy: true
                  }
                ],
                null,
                false,
                4124739800
              )
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }